import { Button, Span } from '@fareye/ui'
import { MdStarBorder } from '@fareye/utils'
import React from 'react'
import { saveFavouriteButtonStyle } from '../../../style/styled'
import { ISaveFavourite } from '../../../utility/types'
import { useTranslation } from '../../..'

function SaveFavourites({ setShowAddFavModal }: ISaveFavourite) {
  const { t } = useTranslation()
  return (
    <Button
      leftChild={<MdStarBorder style={{ marginRight: 8 }} size={14} />}
      onClick={() => setShowAddFavModal(true)}
      style={saveFavouriteButtonStyle}
    >
      {t('Save this Search')}
    </Button>
  )
}

export default SaveFavourites
